import React from "react";

const UserPageContext = React.createContext();

export { UserPageContext };
